import React from "react";

export default function IconNotifications() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_629_81)">
        <path
          d="M7.23462 18.1958C7.7041 19.2572 8.7666 20 9.99988 20C11.2332 20 12.2956 19.2572 12.7651 18.1958H7.23462Z"
          fill="#"
        />
        <path
          d="M9.99976 1.91081C10.8136 1.91081 11.595 2.0544 12.3202 2.3173V2.22797C12.3202 0.99946 11.3208 0 10.0923 0H9.90766C8.67915 0 7.67969 0.99946 7.67969 2.22797V2.31616C8.40448 2.05405 9.18569 1.91081 9.99976 1.91081Z"
          fill="#"
        />
        <path
          d="M17.3233 17.022H2.6766C2.3995 17.022 2.14568 16.8351 2.08805 16.564C2.031 16.2957 2.15331 16.0308 2.40146 15.9161C2.46034 15.8779 2.90357 15.568 3.34731 14.6303C4.16229 12.9083 4.33335 10.4827 4.33335 8.75099C4.33335 5.6265 6.87532 3.08462 9.99976 3.08462C13.1168 3.08462 15.6541 5.61426 15.6661 8.72849C15.6664 8.73596 15.6666 8.74348 15.6666 8.75099C15.6666 10.4827 15.8376 12.9083 16.6526 14.6303C17.0963 15.568 17.5395 15.878 17.5985 15.9161C17.8466 16.0308 17.969 16.2956 17.9119 16.564C17.8542 16.8351 17.6005 17.022 17.3233 17.022Z"
          fill="#"
        />
      </g>
      <defs>
        <clipPath id="clip0_629_81">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
